"use client";

import cls from './Footer.module.css';
import Link from 'next/link';
import { Linkedn, Instagram, Telegram, UpToWork, GoodFirm, Clutch, Email, Location, AtIcon } from '@/utils/images/Socials';
import { Button } from '../UI/Button/Button';
import { useIsMobile } from '@/hooks/useIsMobile';
import { MAIN_NAVIGATION_LINKS } from '@/utils/navLinks';
import { socialsLinks } from '@/utils/socialsLinks';
import Image from 'next/image';

export const Footer = () => {
    const socials = [
        { name: "LinkedIn", href: socialsLinks.linkedin, icon: <Linkedn /> },
        { name: "Instagram", href: socialsLinks.instagram, icon: <Instagram /> },
        { name: "GoodFirm", href: socialsLinks.goodFirm, icon: <GoodFirm /> },
        { name: "UpToWork", href: socialsLinks.upToWork, icon: <UpToWork /> },
        { name: "Telegram", href: socialsLinks.telegram, icon: <Telegram /> },
        { name: "Clutch", href: socialsLinks.clutch, icon: <Clutch /> },
    ];

    const isMobile = useIsMobile();

    return (
        <footer className={cls.footer}>
            <div className={cls.container}>
                <div className={cls.upperContainer}>
                    <div className={cls.logo}>
                        <Image src="/logo.svg" alt="UData Logo" width={150} height={50} />
                    </div>
                    {isMobile &&
                        <div className={cls.contactInfo}>
                            <Button href="mailto:dmytro@udata.company" className={cls.email} invert>
                                <span>dmytro@udata.company</span>
                                <Email />
                            </Button>
                            <Button className={cls.location} invert>
                                <span>Kyiv, Ukraine</span>
                                <Location />
                            </Button>
                        </div>
                    }
                    <nav className={`${cls.nav}`}>
                        <ul>
                            {MAIN_NAVIGATION_LINKS.filter(link => link.footer).map((link) => (
                                <li key={link.name}>
                                    <Link
                                        href={link.href}
                                        aria-label={`Navigate to ${link.name} page`}
                                        prefetch={link.prefetch}
                                    >
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
                <div className={cls.lowerContainer}>
                    <div className={cls.socials}>
                        {!isMobile &&
                            <div className={cls.contactInfo}>
                                <Button href="mailto:dmytro@udata.company" className={cls.email} invert>
                                    <span>dmytro@udata.company</span>
                                    <Email />
                                </Button>
                                <Button className={cls.location} invert>
                                    <span>Kyiv, Ukraine</span>
                                    <Location />
                                </Button>
                            </div>
                        }
                        <div className={cls.socialLinks}>
                            {socials.filter(link => link.href).map((link) => (
                                <Button key={link.name} className={cls.socialLink} href={link.href} invert target ariaLabel={`Visit UData's ${link.name} profile`}>
                                    {link.icon}
                                </Button>
                            ))}
                        </div>
                    </div>
                    <div className={cls.rights}>
                        <span>UData Company, {new Date().getFullYear()}</span>
                        <span>All rights reserved</span>
                        <div className={cls.atIcon}><AtIcon /></div>
                    </div>
                </div>
            </div>
        </footer>
    )
}